// @ts-ignore
import isExtractableFile from 'extract-files/isExtractableFile.mjs';
// @ts-ignore
import extractFiles from 'extract-files/extractFiles.mjs';
import { NamedOptions } from 'apollo-angular/types';
import { HttpLink } from 'apollo-angular/http';
import { APOLLO_FLAGS, APOLLO_NAMED_OPTIONS, APOLLO_OPTIONS, ApolloModule } from 'apollo-angular';
import { onError } from '@apollo/client/link/error';
import { from, InMemoryCache } from '@apollo/client/core';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

import { createErrorHandler } from './graphql.error-handler';
import { ApolloService } from './apollo.service';

import { environment } from '@wo-environments';
import { ToastService } from '@iss/core/portal';

const factory = (httpLink: HttpLink, toast: ToastService, auth = false) => ({
  link: from([
    onError(createErrorHandler(toast)),
    httpLink.create({
      uri: `${ environment.backendHost }/graphql${auth ? '?auth' : '' }`,
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-return
      extractFiles: body => extractFiles(body, isExtractableFile),
    }),
  ]),
  cache: new InMemoryCache(),
});

@NgModule({
  imports: [
    HttpClientModule,
  ],
  exports: [ ApolloModule ],
  providers: [
    HttpLink,
    {
      provide: APOLLO_FLAGS,
      useValue: {
        useInitialLoading: true,
        useMutationLoading: true,
      },
    },
    {
      provide: APOLLO_OPTIONS,
      useFactory: (httpLink: HttpLink, toast: ToastService) => factory(httpLink, toast, true),
      deps: [ HttpLink, ToastService ],
    },
    {
      provide: APOLLO_NAMED_OPTIONS,
      useFactory: (httpLink: HttpLink, toast: ToastService): NamedOptions => ({ open: factory(httpLink, toast) }),
      deps: [ HttpLink, ToastService ],
    },
    ApolloService,
  ],
})
export class GraphQLModule {}
